import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import FotoBiblio from "../element/FotoBiblio";
import CarPrestamosActivos from "../element/CardPrestamosBiblio";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import Footer from './Footer';

const PrestamosActivos = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  const [prestamos, setPrestamos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      GetFetch.prestamosActivos(dataUser.carnet, dataUser.token)
      .then((dataPrestamos) => {
          setPrestamos(dataPrestamos);
          setCargando(false);
        }
      ).catch(() => setCargando(false));

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Libros en préstamo</h2>

        {cargando ? (
          <SkeletonCard rows={4} />
        ) : prestamos.length > 0 ? (
          prestamos.map((element, i) => (
            <div className="card mb-3" key={`${element.idcat}-${i}`}>
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-12 col-sm-3">
                    <FotoBiblio
                      foto={element.portada}
                      alt='Libro de biblioteca CCESEN'
                      tamanio='rounded mx-auto d-block'
                    />
                  </div>
                  <div className="col-12 col-sm-9">
                    <CarPrestamosActivos
                      titulo={element.titulo}
                      inventario={element.idcat}
                      devolucion={element.datedev}
                      complemento={element.complemento}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <EmptyState icon="fa-book" title="Aún no tienes libros en préstamo">
            Cuando retires un libro del CCESEN, aparecerá aquí con su fecha de devolución.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default PrestamosActivos;
